/** Abas, busca da URL e rotulos das compras de MP (so texto e periodo; nenhum valor monetario). */
import type { StatusEntregaCompra, StatusPagamentoCompra } from '@triade/contracts';

export { deslocarMes, mesAtual, rotuloMes } from './carteira-mes';

export const ABAS_COMPRAS = ['compras', 'recebimento'] as const;
export type AbaCompras = (typeof ABAS_COMPRAS)[number];

const RE_MES = /^\d{4}-(0[1-9]|1[0-2])$/;

/** Busca da URL: `mes` (AAAA-MM) e `aba`. Valor invalido e descartado (volta ao padrao). */
export function lerBuscaCompras(bruto: Record<string, unknown>): { mes?: string; aba?: AbaCompras } {
  const mes = typeof bruto.mes === 'string' && RE_MES.test(bruto.mes) ? bruto.mes : undefined;
  const aba = ABAS_COMPRAS.find((a) => a === bruto.aba);
  return { ...(mes ? { mes } : {}), ...(aba ? { aba } : {}) };
}

/** Periodo de um mes para os campos de data ("de" = dia 1; "ate" = ultimo dia, so calendario). */
export function periodoDoMes(mes: string): { de: string; ate: string } {
  const [ano, m] = mes.split('-').map(Number) as [number, number];
  const ultimo = new Date(ano, m, 0).getDate();
  return { de: `${mes}-01`, ate: `${mes}-${String(ultimo).padStart(2, '0')}` };
}

export const ROTULO_ENTREGA: Record<StatusEntregaCompra, string> = {
  A_ENTREGAR: 'A entregar',
  PREVISTO: 'Previsto',
  ENTREGUE: 'Entregue',
  REPROGRAMAR: 'Reprogramar',
};
export const ENTREGAS_ORDEM: readonly StatusEntregaCompra[] = ['A_ENTREGAR', 'PREVISTO', 'ENTREGUE', 'REPROGRAMAR'];

export const ROTULO_PAGAMENTO: Record<StatusPagamentoCompra, string> = {
  A_PAGAR: 'A pagar',
  PAGO: 'Pago',
};
export const PAGAMENTOS_ORDEM: readonly StatusPagamentoCompra[] = ['A_PAGAR', 'PAGO'];
